import { useContext } from "react";
import { Link } from "react-router-dom";

import { useAuthUser } from "../../hooks/useAuthUser";
import { SeasonContext } from "../../store/SeasonContext";

import BusinessOrderList from "./BusinessOrderList";
import "./BusinessDashboard.css";
import FloatingMenu from "../../components/menu/FloatingMenu";
import BusinessClosedPage from "./BusinessClosedPage";

const BusinessDashboard = () => {
  const { isBusinessOpen } = useContext(SeasonContext);
  const { isBusiness, details } = useAuthUser();

  if (!isBusiness) {
    return <>You need to be a Business to access this page</>;
  }

  return isBusinessOpen ? (
    <div className="page-container">
      <h1 className="business-header">Welcome {details?.companyName}!</h1>
      <div className="btn-aligned-right-box business-new-order-btn">
        <Link
          to="/dashboard/business/new-order"
          className="btn btn-aligned-right"
        >
          New Order
        </Link>
      </div>

      <div className="page-content">
        <BusinessOrderList />
      </div>
      <FloatingMenu logoutButton={true} homeButton={true} isBusiness={true} />
    </div>
  ) : (
    <BusinessClosedPage />
  );
};
export default BusinessDashboard;
